import {
  Select,
  SelectItem,
  SelectPopover,
  SelectProvider,
  SelectSeparator
} from '@ariakit/react/select';
import { Link } from '@remix-run/react';
import { domAnimation, motion } from 'framer-motion';
import { useState } from 'react';
import type { MenuItem } from 'types/capi/plp';

import ChevronIcon from '~/assets/icons/Chevron';
import FramerMotion from '~/components/FramerMotion';

type Props = {
  options: MenuItem[];
};

const SortOptions = ({ options }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <SelectProvider open={isOpen}>
      <Select onClick={() => setIsOpen(!isOpen)}>
        <div className="flex items-center gap-2 p-0 text-sm">
          Sort by
          <div className={isOpen ? 'rotate-180' : ''}>
            <ChevronIcon stroke="black" width="10" height="10" />
          </div>
        </div>
      </Select>
      <FramerMotion feature={domAnimation}>
        <SelectPopover
          render={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />
          }
          onClose={() => setIsOpen(false)}
          preventBodyScroll
          wrapperProps={{ className: 'flex grow w-1/2 lg:w-1/6 md:w-1/4' }}
          className="z-10 flex grow flex-col rounded bg-white shadow-lg"
        >
          {options.map((option, index) => (
            <div key={option.text}>
              <SelectItem
                value={option.text}
                className={
                  option.active
                    ? 'pointer-events-none font-bold'
                    : 'font-normal'
                }
              >
                <Link to={option.path} rel="nofollow">
                  <button className="flex self-stretch p-4 text-sm">
                    {option.text}
                  </button>
                </Link>
              </SelectItem>
              <SelectSeparator
                className={
                  index < options.length - 1
                    ? 'w-full border-solid border-concrete'
                    : ''
                }
              />
            </div>
          ))}
        </SelectPopover>
      </FramerMotion>
    </SelectProvider>
  );
};

export default SortOptions;
